import React, { Component } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
  TextField,
  CircularProgress
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { injectIntl } from 'react-intl';
import * as UserDistributionConfigService from '../../../../services/userdistributionconfig.service';

class DistributionConfig extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      config: {
        maxSimultaneousCalleds: 10,
        maxSimultaneousChats: 5,
        distributionWeight: 1,
        active: true
      }
    };
  }

  componentDidMount() {
    this.loadConfig();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.userId !== this.props.userId && this.props.userId) {
      this.loadConfig();
    }
  }

  loadConfig = async () => {
    const { userId, onChange } = this.props;
    if (!userId) {
      this.setState({ loading: false });
      // Notify parent with default config even if no userId
      if (onChange) {
        onChange(this.state.config);
      }
      return;
    }

    try {
      const result = await UserDistributionConfigService.getByUserId(userId);
      if (result && result.data) {
        const data = result.data;
        const config = {
          maxSimultaneousCalleds: data.maxsimultaneouscalleds || data.maxSimultaneousCalleds || 10,
          maxSimultaneousChats: data.maxsimultaneouschats || data.maxSimultaneousChats || 5,
          distributionWeight: data.distributionweight || data.distributionWeight || 1,
          active: data.active !== false
        };
        this.setState({ config, loading: false }, () => {
          // Notify parent with loaded config
          if (onChange) {
            onChange(config);
          }
        });
      } else {
        this.setState({ loading: false }, () => {
          // Notify parent with default config
          if (onChange) {
            onChange(this.state.config);
          }
        });
      }
    } catch (error) {
      console.error('Error loading distribution config:', error);
      this.setState({ loading: false }, () => {
        // Notify parent with default config on error
        if (onChange) {
          onChange(this.state.config);
        }
      });
    }
  };

  handleChange = (field) => (event) => {
    const value = parseInt(event.target.value, 10) || 0;
    this.setState(prevState => ({
      config: {
        ...prevState.config,
        [field]: value
      }
    }), () => {
      if (this.props.onChange) {
        this.props.onChange(this.state.config);
      }
    });
  };

  getConfig = () => {
    return this.state.config;
  };

  render() {
    const { intl, classes, disabled } = this.props;
    const { loading, config } = this.state;

    if (loading) {
      return (
        <Accordion style={{ marginTop: '6px', marginBottom: '10px' }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="distribution-config-content"
            id="distribution-config-header"
          >
            <Typography className={classes?.heading}>
              {intl.formatMessage({ id: 'distribution.config' })}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container justifyContent="center">
              <CircularProgress />
            </Grid>
          </AccordionDetails>
        </Accordion>
      );
    }

    return (
      <Accordion style={{ marginTop: '6px', marginBottom: '10px' }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="distribution-config-content"
          id="distribution-config-header"
        >
          <Typography className={classes?.heading}>
            {intl.formatMessage({ id: 'distribution.config' })}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                type="number"
                label={intl.formatMessage({ id: 'distribution.max.simultaneous.calleds' })}
                value={config.maxSimultaneousCalleds}
                onChange={this.handleChange('maxSimultaneousCalleds')}
                disabled={disabled}
                inputProps={{ min: 0, max: 999 }}
                helperText={intl.formatMessage({ id: 'distribution.max.simultaneous.calleds' })}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                type="number"
                label={intl.formatMessage({ id: 'distribution.max.simultaneous.chats' })}
                value={config.maxSimultaneousChats}
                onChange={this.handleChange('maxSimultaneousChats')}
                disabled={disabled}
                inputProps={{ min: 0, max: 999 }}
                helperText={intl.formatMessage({ id: 'distribution.max.simultaneous.chats' })}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                type="number"
                label={intl.formatMessage({ id: 'distribution.weight' })}
                value={config.distributionWeight}
                onChange={this.handleChange('distributionWeight')}
                disabled={disabled}
                inputProps={{ min: 1, max: 10 }}
                helperText="1-10"
              />
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    );
  }
}

export default injectIntl(DistributionConfig, { forwardRef: true });
